import React from 'react';
import { MenuItem, TextField } from '@mui/material';
const SelectExecutionStyle = ({ value, onChange }) => (React.createElement("div", null,
    React.createElement(TextField, { select: true, fullWidth: true, size: "small", variant: "outlined", label: "Split strategy", name: "selectExecutionStyle", value: value.value, onChange: (event) => onChange({ value: event.target.value, label: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1) }) },
        React.createElement(MenuItem, { value: "manual" }, "Manual"),
        React.createElement(MenuItem, { value: "aggressive" }, "Aggressive"),
        React.createElement(MenuItem, { value: "conservative" }, "Conservative"))));
export default SelectExecutionStyle;
